import { faCalendar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import { FunctionComponent, memo } from "react";
import { IProps } from "./anomaly-phrase-counts-chart-filters.types";
import { SelectEnum, SelectField } from "@edgetier/select";
import { SubmitOnChange } from "@edgetier/components";
import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import Toggle from "components-for/filters/toggle";
import { RANGE_DAYS } from "../anomaly-phrase-counts-chart.constants";
import "./anomaly-phrase-counts-chart-filters.scss";

/**
 * Choose some display options on the phrase counts chart.
 * @returns Form containing options for range, grouping, and axis.
 */
const AnomalyPhraseCountsChartFilters: FunctionComponent<IProps> = ({
    filterRange = true,
    initialValues,
    onChange,
}) => {
    return (
        <Formik initialValues={initialValues} onSubmit={onChange}>
            <Form className="anomaly-phrase-counts-chart-filters" name="anomaly-phrase-counts-chart-filters">
                {filterRange && (
                    <div className="field field-inline">
                        <div className="field-inline__icon">
                            <FontAwesomeIcon icon={faCalendar} />
                        </div>
                        <SelectField<number, number>
                            description="day range"
                            name="dayRange"
                            getLabel={(days) => `${days} days before & after`}
                            getValue={(days) => days}
                            items={RANGE_DAYS}
                            isSingleSelect
                            isSearchable={false}
                            isFilter={false}
                            isClearable={false}
                        />
                    </div>
                )}

                <div className="field field-inline">
                    <div className="field-inline__icon">
                        <FontAwesomeIcon icon={faCalendar} />
                    </div>
                    <SelectEnum
                        isFilter={false}
                        isSingleSelect
                        isClearable={false}
                        name="groupBy"
                        items={TimePeriodGroupBy}
                        placeholder="Group by..."
                        description="group"
                        isSearchable={false}
                    />
                </div>

                <div className="proportion-toggle">
                    <Toggle name="proportion" leftLabel="Absolute" rightLabel="Percent" />
                </div>

                <SubmitOnChange />
            </Form>
        </Formik>
    );
};

export default memo(AnomalyPhraseCountsChartFilters);
